<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- Breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Monitoring</a></li>
          <li><a>CM Live</a></li>
        </ul>
      </div>
      <!-- Breadcrumb End -->

      <!-- Block Container -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Continuous Water Monitoring Live</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="refereshFunction()"/>
        </div>

        <!-- Filter Form Row -->
        <div class="Reports_form_div margin-top-15">
          <form role="form" name="addmapdevice" (ngSubmit)="cwmReports()">
            <div class="row align-items-center">
              <div class="col-md-6 col-xs-12" *ngIf="customerDevices && customerDevices.length > 0">
                <mat-form-field appearance="outline" class="w-100 density-compact">
                  <mat-label>Device Serial Number</mat-label>
                  <mat-select name="business" [(ngModel)]="continuousWaterReading.serial_number" required>
                    <mat-option [value]="undefined" disabled>Select Serial number</mat-option>
                    <mat-option *ngFor="let device of customerDevices" [value]="device?.device?.serial_number">
                      {{ device?.device?.serial_number }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-6 col-xs-12" *ngIf="customerDevices && customerDevices.length === 0">
                <p style="font-size: 15px; font-weight: 500; color: #64748b;">Continuous monitoring devices are not available.</p>
              </div>

              <div class="col-md-6 col-xs-12 text-right" *ngIf="customerDevices && customerDevices.length > 0">
                <div class="buttons-div reports_search_div" style="float: right;">
                  <div class="transactions-button-container">
                    <button type="submit" class="transaction-submit-button">
                      <span class="icon"><img src="assets/images/New_Icons/search-icon.svg" alt="Search icon"></span>
                      <span class="text">Search</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Loader -->
        <div *ngIf="!responseLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>

        <!-- Results Table Block -->
        <div class="reports_block margin-top-15" *ngIf="responseLoader && tabledatadisplay && continuousWaterReadings && continuousWaterReadings.length > 0">
          <div class="row margin-bottom-10" style="padding: 0 15px;">
            <div class="buttons-div reports_search_div" style="float: right;">
              <div class="transactions-button-container">
                <button type="button" class="transaction-submit-button" (click)="exportExcel()">
                  <span class="icon"><img src="assets/img/icons/excel_icon.svg" alt="Excel icon"></span>
                  <span class="text">Excel Export</span>
                </button>
              </div>
            </div>
          </div>
          <div class="table-responsive" id="zoomView">
            <table class="table table-striped table-bordered table-hover text-centre">
              <thead>
                <tr>
                  <th>Date(Time)</th>
                  <th>Pond Name</th>
                  <th>Section Name</th>
                  <th>pH</th>
                  <th>Temperature</th>
                  <th>DO</th>
                  <th>Time Interval</th>
                  <th>Test Type</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let list of continuousWaterReadings | paginate: { itemsPerPage: noofitemsPerPage, currentPage: currentpagenum }; let i = index">
                  <td>{{ list.time | date: "dd-MMM-yyyy hh:mm:ss a" }}</td>
                  <td>{{ list.pond_name }}</td>
                  <td>{{ list.section_name }}</td>
                  <td>{{ list.pH }}</td>
                  <td style="text-align: center;">{{ list.temperature ? list.temperature.toFixed(2) : 'NA' }}</td>
                  <td>{{ list.do2 }}</td>
                  <td style="text-align: center;">{{ list.time_interval }}</td>
                  <td style="text-align: center;">{{ list.test_type }}</td>
                </tr>
              </tbody>
            </table>
            <div class="pull-right pagination_div margin-top-15" *ngIf="continuousWaterReadings && continuousWaterReadings.length > noofitemsPerPage">
              <pagination-controls (pageChange)="currentpagenum = $event"></pagination-controls>
            </div>
          </div>
        </div>

        <div *ngIf="tabledatadisplay && (!continuousWaterReadings || continuousWaterReadings.length === 0)" class="noDataFoundMessage margin-top-15">
          No Continuous Monitoring Readings Available
        </div>
      </div>
    </div>
  </div>
</div>
